/**
 * Contains logic to switch between native and wrapped currencies
 */
import BigNumber from 'bignumber.js';
import { Network } from '@kattana-io/common';
import { ICoin } from '../reducers/dex/tradingReducer';
import { kavaChain, tonChain } from '../../../helpers/customChains';

enum Chain {
  ETH = 1,
  BSC = 56,
  POLYGON = 137,
  FTM = 250,
  AVAX = 43114,
  ARTHERA = 10242,
}

const BASE_TOKEN = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
const PROXY_TON = 'EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez';

const SUPPORTED_CHAINS = [
  Chain.ETH,
  Chain.BSC,
  Chain.POLYGON,
  Chain.FTM,
  Chain.AVAX,
  Chain.ARTHERA,
];

const isNative = (token?: string): boolean =>
  token?.toLocaleLowerCase() == BASE_TOKEN;

const Native_Coin = (
  name: string,
  chain: string,
  amount: BigNumber,
  address = BASE_TOKEN,
  decimals = 18
): ICoin => ({
  name,
  amount,
  symbol: name,
  decimals,
  address,
  chain,
});

const NativeCoin = (chainId: number, amount: BigNumber): ICoin => {
  const network = Network.fromChainId(chainId);
  const nativeSymbol = network.getNativeCurrencySymbol();

  if (network.isELROND()) {
    return Native_Coin(nativeSymbol, network.getSlug(), amount, '');
  }
  if (network.isTON()) {
    return Native_Coin(
      nativeSymbol,
      network.getSlug(),
      amount,
      PROXY_TON,
      tonChain.nativeCurrency.decimals
    );
  }
  if (network.isKAVA()) {
    return Native_Coin(
      nativeSymbol,
      network.getSlug(),
      amount,
      BASE_TOKEN,
      kavaChain.nativeCurrency.decimals
    );
  }

  return Native_Coin(nativeSymbol, network.getSlug(), amount);
};

export { BASE_TOKEN, PROXY_TON, SUPPORTED_CHAINS, isNative, NativeCoin };
